import { IView, IViewLike, View } from "@dhx/ts-common/view";
import { VNode } from "@dhx/ts-common/dom";
import { IEventSystem } from "@dhx/ts-common/events";

export interface ICellConfig {
	id?: string;
	html?: string;
	hidden?: boolean;
	header?: string;
	headerIcon?: string;
	headerImage?: string;

	on?: {
		[key: string]: any;
	};

	width?: string;
	height?: string;
	gravity?: boolean;
	css?: string;
	padding?: string | number;
	align?: "start" | "center" | "end" | "between" | "around" | "evenly";

	collapsable?: boolean;
	resizable?: boolean;
	collapsed?: boolean;
	tab?: string;
	tabCss?: string;
	full?: boolean;
}
export interface ILayoutConfig extends ICellConfig {
	rows?: ICellConfig[] | ILayoutConfig[];
	cols?: ICellConfig[] | ILayoutConfig[];
	views?: ICellConfig[] | ILayoutConfig[];
	activeView?: string;
	parent?: ILayout;
}
export type IViewFn = (cfg: any) => VNode;
export interface IViewConstructor {
	new: (container: HTMLElement | string, config: any) => IView;
}
export interface ICell extends IView {
	id: string;
	config: ICellConfig;
	events: IEventSystem<LayoutEvents, ILayoutEventHandlersMap>;
	attach(name: string | IViewFn | IView | IViewConstructor, config?: any): IViewLike;
	attachHTML(html: string): void;
	isVisible(): boolean;
	toVDOM(nodes?: any[]): any;
	getParent(): ILayout;
	show(): void;
	hide(): void;
	paint(): void;
	destructor(): void;
	getWidget(): any;
}
export interface ILayout extends ICell {
	config: ILayoutConfig;
	removeCell(id: string): any;
	addCell(config: ICellConfig, index: number): any;
	getRefs(str: any): any;
	getCell(id: string): ICell;

	// TODO: remove sute_7.0
	cell(id: string): ICell;
}
export enum LayoutEvents {
	beforeShow = "beforeShow",
	afterShow = "afterShow",
	beforeHide = "beforeHide",
	afterHide = "afterHide",

	beforeResizeStart = "beforeResizeStart",
	resize = "resize",
	afterResizeEnd = "afterResizeEnd",

	beforeAdd = "beforeAdd",
	afterAdd = "afterAdd",
	beforeRemove = "beforeRemove",
	afterRemove = "afterRemove",

	beforeCollapse = "beforeCollapse",
	afterCollapse = "afterCollapse",
}
export interface ILayoutEventHandlersMap {
	[key: string]: (...args: any[]) => any;
	[LayoutEvents.beforeShow]: (id: string) => boolean | void;
	[LayoutEvents.afterShow]: (id: string) => any;
	[LayoutEvents.beforeHide]: (id: string) => boolean | void;
	[LayoutEvents.afterHide]: (id: string) => any;

	[LayoutEvents.beforeResizeStart]: (id: string) => boolean | void;
	[LayoutEvents.resize]: (id: string) => void;
	[LayoutEvents.afterResizeEnd]: (id: string) => void;

	[LayoutEvents.beforeAdd]: (id: string) => boolean | void;
	[LayoutEvents.afterAdd]: (id: string) => void;
	[LayoutEvents.beforeRemove]: (id: string) => boolean | void;
	[LayoutEvents.afterRemove]: (id: string) => void;

	[LayoutEvents.beforeCollapse]: (id: string) => boolean | void;
	[LayoutEvents.afterCollapse]: (id: string) => void;
}
export enum resizeMode {
	unknown,
	percents,
	pixels,
	mixedpx1,
	mixedpx2,
	mixedperc1,
	mixedperc2
}